import React, { useEffect, useState } from "react";
import Parse from "parse";
import { useDispatch } from "react-redux";
import axios from "axios";
import Title from "../components/Title";
import GoogleSignInBtn from "../components/LoginGoogle";
// import LoginFacebook from "../components/LoginFacebook";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import login_img from "../assets/images/login_img.svg";
import { useWindowSize } from "../hook/useWindowSize";
import ModalUi from "../primitives/ModalUi";
import { isEnableSubscription } from "../constant/const";
import Alert from "../primitives/Alert";
import { appInfo } from "../constant/appinfo";
import { fetchAppInfo } from "../redux/reducers/infoReducer";
import { showTenant } from "../redux/reducers/ShowTenant";
import {
  fetchSubscription,
  getAppLogo,
  openInNewTab,
  saveLanguageInLocal
} from "../constant/Utils";
import Loader from "../primitives/Loader";
import { useTranslation } from "react-i18next";
import SelectLanguage from "../components/pdf/SelectLanguage";

function Login() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const [state, setState] = useState({
    email: "",
    alertType: "success",
    alertMsg: "",
    password: "",
    passwordVisible: false,
    mobile: "",
    phone: "",
    scanResult: "",
    baseUrl: localStorage.getItem("baseUrl"),
    parseAppId: localStorage.getItem("parseAppId"),
    loading: false,
    thirdpartyLoader: false
  });
  const [userDetails, setUserDetails] = useState({
    Company: "",
    Destination: ""
  });
  const [isModal, setIsModal] = useState(false);
  const [image, setImage] = useState();
  const [isLoginSSO, setIsLoginSSO] = useState(false);
  const [errMsg, setErrMsg] = useState();
  const forgotPasswordLink =
    process.env.REACT_APP_FORGOT_PASSWORD_LINK || "/forgetpassword";
  const isExternalForgotPasswordLink = /^https?:\/\//i.test(forgotPasswordLink);

  // Redirect to SSO before rendering login page if enabled and not already authenticated
  useEffect(() => {
    if (
      isEnableSubscription &&
      !localStorage.getItem("accesstoken") &&
      !isLoginSSO
    ) {
      setIsLoginSSO(true);
      const clientUrl = window.location.origin;
      const keycloakUrl =
        process.env.REACT_APP_KEYCLOAK_URL || "https://auth.brightarchive.com";
      const realm = process.env.REACT_APP_KEYCLOAK_REALM || "master";
      const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "opensign";
      const redirectUri = `${clientUrl}/sso`;
      const nonce =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem("oidc_nonce", nonce);
      const state =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem("oidc_state", state);
      openInNewTab(
        `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
          redirectUri
        )}&response_type=code&scope=openid%20email%20profile%20organization&state=${state}&nonce=${nonce}`,
        "_self"
      );
    }
  }, []);

  useEffect(() => {
    checkUserExt();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isEnableSubscription && !localStorage.getItem("accesstoken")) {
      handleSignInWithSSO();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkUserExt = async () => {
    // Initialize app info first to ensure settings are available
    dispatch(fetchAppInfo());

    const app = await getAppLogo();
    if (app?.error === "invalid_json") {
      setErrMsg(t("server-down"));
    } else if (!isEnableSubscription && app?.user === "not_exist") {
      navigate("/addadmin");
    }
    if (app?.logo) {
      setImage(app?.logo);
    } else {
      setImage(appInfo?.applogo || undefined);
    }
    if (localStorage.getItem("accesstoken")) {
      setState({ ...state, loading: true });
      GetLoginData();
    }
  };
  const handleChange = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value?.toLowerCase()?.replace(/\s/g, "");
    }
    setState({ ...state, [name]: value });
  };
  const handlePaidRoute = () => {
    navigate("/subscription");
  };
  const handleSubmit = async (event) => {
    localStorage.removeItem("accesstoken");
    event.preventDefault();
    const { email, password } = state;
    if (email && password) {
      try {
        setState({ ...state, loading: true });
        localStorage.setItem("appLogo", appInfo.applogo);
        // Pass the username and password to logIn function
        const user = await Parse.Cloud.run("loginuser", { email, password });
        console.log("user login ", user);
        if (!user) {
          setState({ ...state, loading: false });
          return;
        }
        if (user) {
          let _user = user;

          // Check if password is expired
          if (_user.passwordExpiryStatus?.isExpired) {
            console.log(
              "Password expired, redirecting to force change password"
            );
            localStorage.setItem("UserInformation", JSON.stringify(_user));
            localStorage.setItem("userEmail", email);
            localStorage.setItem("accesstoken", _user.sessionToken);
            localStorage.setItem("scriptId", true);

            // Authenticate Parse SDK with the session token
            await Parse.User.become(_user.sessionToken);

            // Redirect to force change password page
            setState({ ...state, loading: false });
            navigate("/forcechangepassword");
            return;
          }

          localStorage.setItem("UserInformation", JSON.stringify(_user));
          localStorage.setItem("userEmail", email);
          localStorage.setItem("accesstoken", _user.sessionToken);
          localStorage.setItem("scriptId", true);
          if (_user.ProfilePic) {
            localStorage.setItem("profileImg", _user.ProfilePic);
          } else {
            localStorage.setItem("profileImg", "");
          }
          // Authenticate Parse SDK with the session token
          await Parse.User.become(_user.sessionToken);

          // Check extended class user role and tenentId
          try {
            const storedSettings = localStorage.getItem("userSettings");
            const userSettings = storedSettings
              ? JSON.parse(storedSettings)
              : appInfo?.settings;
            if (
              !userSettings ||
              !Array.isArray(userSettings) ||
              userSettings.length === 0
            ) {
              setState({
                ...state,
                loading: false,
                alertType: "danger",
                alertMsg:
                  "Application configuration error. Please contact support."
              });
              setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
              return;
            }
            await Parse.Cloud.run("getUserDetails")
              .then(async (extUser) => {
                if (extUser) {
                  // Check if user is superadmin (plain object, not Parse Object)
                  if (extUser.isSuperAdmin === true) {
                    // Superadmin login - redirect to superadmin dashboard
                    localStorage.setItem("_user_role", "superadmin");
                    localStorage.setItem(
                      "username",
                      extUser.Name || _user.name
                    );
                    localStorage.setItem(
                      "userEmail",
                      extUser.Email || _user.email
                    );
                    setState({ ...state, loading: false });
                    navigate("/superadmin");
                    return;
                  }

                  // For regular users, extUser is a Parse Object
                  // console.log("extUser", extUser, extUser?.get("IsDisabled"));
                  const IsDisabled = extUser?.get("IsDisabled") || false;
                  if (!IsDisabled) {
                    const userRole = extUser?.get("UserRole");
                    const menu =
                      userRole &&
                      userSettings.find((menu) => menu.role === userRole);
                    if (menu) {
                      const _currentRole = userRole;
                      const redirectUrl =
                        location?.state?.from ||
                        `/${menu.pageType}/${menu.pageId}`;
                      let _role = _currentRole.replace("contracts_", "");
                      localStorage.setItem("_user_role", _role);
                      const checkLanguage = extUser?.get("Language");
                      if (checkLanguage) {
                        checkLanguage && i18n.changeLanguage(checkLanguage);
                      }

                      const results = [extUser];
                      const extUser_str = JSON.stringify(results);

                      localStorage.setItem("Extand_Class", extUser_str);
                      const extInfo = JSON.parse(JSON.stringify(extUser));
                      localStorage.setItem("userEmail", extInfo.Email);
                      localStorage.setItem("username", extInfo.Name);
                      if (extInfo?.TenantId) {
                        const tenant = {
                          Id: extInfo?.TenantId?.objectId || "",
                          Name: extInfo?.TenantId?.TenantName || ""
                        };
                        localStorage.setItem("TenantId", tenant?.Id);
                        dispatch(showTenant(tenant?.Name));
                        localStorage.setItem("TenantName", tenant?.Name);
                      }
                      localStorage.setItem("PageLanding", menu.pageId);
                      localStorage.setItem("defaultmenuid", menu.menuId);
                      localStorage.setItem("pageType", menu.pageType);
                      if (isEnableSubscription) {
                        const LocalUserDetails = {
                          name: results[0].get("Name"),
                          email: results[0].get("Email"),
                          phone: results[0]?.get("Phone") || "",
                          company: results[0].get("Company")
                        };
                        localStorage.setItem(
                          "userDetails",
                          JSON.stringify(LocalUserDetails)
                        );
                        const res = await fetchSubscription();
                        const plan = res.plan;
                        const billingDate = res.billingDate;
                        if (plan === "freeplan") {
                          setState({ ...state, loading: false });
                          navigate(redirectUrl);
                        } else if (billingDate) {
                          if (new Date(billingDate) > new Date()) {
                            localStorage.removeItem("userDetails");
                            // Redirect to the appropriate URL after successful login                              setState({ ...state, loading: false });
                            setState({ ...state, loading: false });
                            navigate(redirectUrl);
                          } else {
                            setState({ ...state, loading: false });
                            handlePaidRoute(plan);
                          }
                        } else {
                          setState({ ...state, loading: false });
                          handlePaidRoute(plan);
                        }
                      } else {
                        setState({ ...state, loading: false });
                        // Redirect to the appropriate URL after successful login
                        navigate(redirectUrl);
                      }
                    } else {
                      setState({ ...state, loading: false });
                      setIsModal(true);
                    }
                  } else {
                    setState({
                      ...state,
                      loading: false,
                      alertType: "danger",
                      alertMsg:
                        "You don't have access, please contact the admin."
                    });
                    logOutUser();
                  }
                } else {
                  console.log(
                    "getUserDetails returned empty - user may not have contracts_Users record"
                  );
                  if (isEnableSubscription) {
                    setState({ ...state, loading: false });
                    setIsModal(true);
                  } else {
                    setState({ ...state, loading: false });
                    setState({
                      ...state,
                      loading: false,
                      alertType: "danger",
                      alertMsg:
                        "User profile not found. Please contact the admin to set up your account."
                    });
                    logOutUser();
                  }
                }
              })
              .catch((error) => {
                // const payload = { sessionToken: user.getSessionToken() };
                // handleSubmitbtn(payload);
                console.error("Error in getUserDetails:", error);
                console.error("Error code:", error.code);
                console.error("Error message:", error.message);

                let errorMsg = "Something went wrong.";
                if (error.code === 209) {
                  errorMsg = "Session expired. Please try logging in again.";
                } else if (error.message) {
                  errorMsg = error.message;
                }

                setState({
                  ...state,
                  loading: false,
                  alertType: "danger",
                  alertMsg: errorMsg
                });
                setTimeout(() => setState({ ...state, alertMsg: "" }), 3000);
              });
          } catch (error) {
            setState({
              ...state,
              loading: false,
              alertType: "danger",
              alertMsg: `${error.message}`
            });
            console.log(error);
            setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
          }
        }
      } catch (error) {
        setState({
          ...state,
          loading: false,
          alertType: "danger",
          alertMsg: "Invalid username or password!"
        });
        console.error("Error while logging in user", error);
      } finally {
        setTimeout(() => setState((prev) => ({ ...prev, alertMsg: "" })), 2000);
      }
    }
  };

  const setThirdpartyLoader = (value) => {
    setState({ ...state, thirdpartyLoader: value });
  };
  const handleFreePlan = async (id) => {
    try {
      const params = { userId: id };
      const res = await Parse.Cloud.run("freesubscription", params);
      if (res.status === "error") {
        alert(res.result);
      }
    } catch (err) {
      console.log("err in free subscribe", err.message);
      alert(t("something-went-wrong-mssg"));
    }
  };
  const thirdpartyLoginfn = async (sessionToken) => {
    const baseUrl = localStorage.getItem("baseUrl");
    const parseAppId = localStorage.getItem("parseAppId");
    const res = await axios.get(baseUrl + "users/me", {
      headers: {
        "X-Parse-Session-Token": sessionToken,
        "X-Parse-Application-Id": parseAppId
      }
    });
    const param = new URLSearchParams(location.search);
    const isFreeplan = param?.get("subscription") === "freeplan";
    if (isFreeplan) {
      await handleFreePlan(res.data.objectId);
    }
    await Parse.User.become(sessionToken).then(() => {
      window.localStorage.setItem("accesstoken", sessionToken);
    });
    if (res.data) {
      let _user = res.data;
      localStorage.setItem("UserInformation", JSON.stringify(_user));
      localStorage.setItem("userEmail", _user.email);
      localStorage.setItem("accesstoken", _user.sessionToken);
      localStorage.setItem("scriptId", true);
      if (_user.ProfilePic) {
        localStorage.setItem("profileImg", _user.ProfilePic);
      } else {
        localStorage.setItem("profileImg", "");
      }
      // Check extended class user role and tenentId
      try {
        const storedSettings = localStorage.getItem("userSettings");
        const userSettings = storedSettings
          ? JSON.parse(storedSettings)
          : appInfo?.settings;
        if (
          !userSettings ||
          !Array.isArray(userSettings) ||
          userSettings.length === 0
        ) {
          setState({
            ...state,
            alertType: "danger",
            alertMsg: "Application configuration error. Please contact support."
          });
          setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
          return;
        }
        await Parse.Cloud.run("getUserDetails")
          .then(async (extUser) => {
            if (extUser) {
              const IsDisabled = extUser?.get("IsDisabled") || false;
              if (!IsDisabled) {
                const userRole = extUser?.get("UserRole");
                const menu =
                  userRole &&
                  userSettings.find((menu) => menu.role === userRole);
                if (menu) {
                  const _currentRole = userRole;
                  const redirectUrl =
                    location?.state?.from || `/${menu.pageType}/${menu.pageId}`;
                  const _role = _currentRole.replace("contracts_", "");
                  localStorage.setItem("_user_role", _role);
                  const results = [extUser];
                  const extUser_stringify = JSON.stringify(results);
                  localStorage.setItem("Extand_Class", extUser_stringify);
                  const extInfo = JSON.parse(JSON.stringify(extUser));
                  localStorage.setItem("userEmail", extInfo?.Email);
                  localStorage.setItem("username", extInfo?.Name);
                  if (extInfo?.TenantId) {
                    const tenant = {
                      Id: extInfo?.TenantId?.objectId || "",
                      Name: extInfo?.TenantId?.TenantName || ""
                    };
                    localStorage.setItem("TenantId", tenant?.Id);
                    dispatch(showTenant(tenant?.Name));
                    localStorage.setItem("TenantName", tenant?.Name);
                  }
                  localStorage.setItem("PageLanding", menu.pageId);
                  localStorage.setItem("defaultmenuid", menu.menuId);
                  localStorage.setItem("pageType", menu.pageType);
                  if (isEnableSubscription) {
                    const res = await fetchSubscription();
                    const plan = res.plan;
                    const billingDate = res.billingDate;
                    if (plan === "freeplan") {
                      navigate(redirectUrl);
                    } else if (billingDate) {
                      if (new Date(billingDate) > new Date()) {
                        localStorage.removeItem("userDetails");
                        navigate(redirectUrl);
                      } else {
                        if (isFreeplan) {
                          navigate(redirectUrl);
                        } else {
                          handlePaidRoute(plan);
                        }
                      }
                    } else {
                      if (isFreeplan) {
                        navigate(redirectUrl);
                      } else {
                        handlePaidRoute(plan);
                      }
                    }
                  } else {
                    navigate(redirectUrl);
                  }
                } else {
                  setState({
                    ...state,
                    loading: false,
                    alertType: "danger",
                    alertMsg: "Role not found."
                  });
                  logOutUser();
                }
              } else {
                setState({
                  ...state,
                  loading: false,
                  alertType: "danger",
                  alertMsg: "You don't have access, please contact the admin."
                });
                logOutUser();
              }
            } else {
              setState({
                ...state,
                alertType: "danger",
                alertMsg: "User not found."
              });
              logOutUser();
            }
          })
          .catch((err) => {
            console.error("err in fetching extUser", err);
            setState({
              ...state,
              alertType: "danger",
              alertMsg: `${err.message}`
            });
            const payload = { sessionToken: sessionToken };
            handleSubmitbtn(payload);
          });
      } catch (error) {
        setState({
          ...state,
          alertType: "danger",
          alertMsg: `${error.message}`
        });
        console.log(error);
      } finally {
        setThirdpartyLoader(false);
        setState({ ...state, loading: false });
        setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
      }
    }
  };

  const GetLoginData = async () => {
    setState({ ...state, loading: true });
    try {
      const user = await Parse.User.become(localStorage.getItem("accesstoken"));
      const _user = user.toJSON();
      localStorage.setItem("UserInformation", JSON.stringify(_user));
      localStorage.setItem("accesstoken", _user.sessionToken);
      localStorage.setItem("scriptId", true);
      if (_user.ProfilePic) {
        localStorage.setItem("profileImg", _user.ProfilePic);
      } else {
        localStorage.setItem("profileImg", "");
      }
      const storedSettings = localStorage.getItem("userSettings");
      const userSettings = storedSettings
        ? JSON.parse(storedSettings)
        : appInfo?.settings;
      if (
        !userSettings ||
        !Array.isArray(userSettings) ||
        userSettings.length === 0
      ) {
        setState({
          ...state,
          loading: false,
          alertType: "danger",
          alertMsg: "Application configuration error. Please contact support."
        });
        setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
        return;
      }
      await Parse.Cloud.run("getUserDetails").then(async (extUser) => {
        if (extUser) {
          // Check if user is superadmin (plain object)
          if (extUser.isSuperAdmin === true) {
            console.log(
              "Superadmin session detected, redirecting to /superadmin"
            );
            localStorage.setItem("_user_role", "superadmin");
            localStorage.setItem("username", extUser.Name || _user.name);
            localStorage.setItem("userEmail", extUser.Email || _user.email);
            setState({ ...state, loading: false });
            navigate("/superadmin");
            return;
          }

          // For regular users, extUser is a Parse Object
          const IsDisabled = extUser?.get("IsDisabled") || false;
          if (!IsDisabled) {
            const userRole = extUser.get("UserRole");
            const _currentRole = userRole;
            const menu =
              userRole && userSettings.find((menu) => menu.role === userRole);
            if (menu) {
              const _role = _currentRole.replace("contracts_", "");
              localStorage.setItem("_user_role", _role);
              const redirectUrl =
                location?.state?.from || `/${menu.pageType}/${menu.pageId}`;
              const results = [extUser];
              const extendedInfo_stringify = JSON.stringify(results);
              localStorage.setItem("Extand_Class", extendedInfo_stringify);
              const extInfo = JSON.parse(JSON.stringify(extUser));
              localStorage.setItem("userEmail", extInfo.Email);
              localStorage.setItem("username", extInfo.Name);
              if (extInfo?.TenantId) {
                const tenant = {
                  Id: extInfo?.TenantId?.objectId || "",
                  Name: extInfo?.TenantId?.TenantName || ""
                };
                localStorage.setItem("TenantId", tenant?.Id);
                dispatch(showTenant(tenant?.Name));
                localStorage.setItem("TenantName", tenant?.Name);
              }
              localStorage.setItem("PageLanding", menu.pageId);
              localStorage.setItem("defaultmenuid", menu.menuId);
              localStorage.setItem("pageType", menu.pageType);
              if (isEnableSubscription) {
                const userInfo = {
                  name: results[0].get("Name"),
                  email: results[0].get("Email"),
                  phone: results[0]?.get("Phone") || "",
                  company: results[0]?.get("Company")
                };
                localStorage.setItem("userDetails", JSON.stringify(userInfo));
                const res = await fetchSubscription();
                const billingDate = res.billingDate;
                const plan = res.plan;
                if (plan === "freeplan") {
                  navigate(redirectUrl);
                } else if (billingDate) {
                  if (new Date(billingDate) > new Date()) {
                    localStorage.removeItem("userDetails");
                    // Redirect to the appropriate URL after successful login
                    navigate(redirectUrl);
                  } else {
                    handlePaidRoute(plan);
                  }
                } else {
                  handlePaidRoute(plan);
                }
              } else {
                // Redirect to the appropriate URL after successful login
                navigate(redirectUrl);
              }
            } else {
              setState({ ...state, loading: false });
              logOutUser();
            }
          } else {
            setState({
              ...state,
              loading: false,
              alertType: "danger",
              alertMsg: "You don't have access, please contact the admin."
            });
            logOutUser();
          }
        } else {
          setState({
            ...state,
            alertType: "danger",
            alertMsg: "User not found."
          });
          logOutUser();
        }
      });
    } catch (error) {
      setState({
        ...state,
        alertType: "danger",
        alertMsg: "Something went wrong, please try again later."
      });
      console.log("err", error);
    } finally {
      setState({ ...state, loading: false });
      setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
    }
  };

  const togglePasswordVisibility = () => {
    setState({ ...state, passwordVisible: !state.passwordVisible });
  };

  const handleSubmitbtn = async (e) => {
    e.preventDefault();
    if (userDetails.Destination && userDetails.Company) {
      setThirdpartyLoader(true);
      // console.log("handelSubmit", userDetails);
      // const payload = await Parse.User.logIn(state.email, state.password);
      const payload = { sessionToken: localStorage.getItem("accesstoken") };
      const userInformation = JSON.parse(
        localStorage.getItem("UserInformation")
      );
      // console.log("payload ", payload);
      if (payload && payload.sessionToken) {
        const params = {
          userDetails: {
            name: userInformation.name,
            email: userInformation.email,
            phone: userInformation?.phone || "",
            role: "contracts_User",
            company: userDetails.Company,
            jobTitle: userDetails.Destination
          }
        };
        const userSignUp = await Parse.Cloud.run("usersignup", params);
        // console.log("userSignUp ", userSignUp);
        if (userSignUp && userSignUp.sessionToken) {
          const LocalUserDetails = {
            name: userInformation.name,
            email: userInformation.email,
            phone: userInformation?.phone || "",
            company: userDetails.Company,
            jobTitle: userDetails.JobTitle
          };
          localStorage.setItem("userDetails", JSON.stringify(LocalUserDetails));
          thirdpartyLoginfn(userSignUp.sessionToken);
        } else {
          alert(userSignUp.message);
        }
      } else if (
        payload &&
        payload.message.replace(/ /g, "_") === "Internal_server_err"
      ) {
        alert(t("server-error"));
      }
    } else {
      setState({
        ...state,
        loading: false,
        alertType: "warning",
        alertMsg: "Please fill required details."
      });
      setTimeout(() => setState((prev) => ({ ...prev, alertMsg: "" })), 2000);
    }
  };

  const logOutUser = async () => {
    setIsModal(false);
    try {
      await Parse.User.logOut();
    } catch (err) {
      console.log("Err while logging out", err);
    }
    let appdata = localStorage.getItem("userSettings");
    let applogo = localStorage.getItem("appLogo");
    let defaultmenuid = localStorage.getItem("defaultmenuid");
    let PageLanding = localStorage.getItem("PageLanding");
    let baseUrl = localStorage.getItem("baseUrl");
    let appid = localStorage.getItem("parseAppId");

    localStorage.clear();
    saveLanguageInLocal(i18n);

    localStorage.setItem("appLogo", applogo);
    localStorage.setItem("defaultmenuid", defaultmenuid);
    localStorage.setItem("PageLanding", PageLanding);
    localStorage.setItem("userSettings", appdata);
    localStorage.setItem("baseUrl", baseUrl);
    localStorage.setItem("parseAppId", appid);
  };

  // `handleSignInWithSSO` is trigger when user click sign in with sso and open sso authorize endpoint
  const handleSignInWithSSO = () => {
    if (isLoginSSO === false) {
      setIsLoginSSO(true);
      const clientUrl = window.location.origin;
      // Keycloak configuration
      const keycloakUrl =
        process.env.REACT_APP_KEYCLOAK_URL || "https://auth.brightarchive.com";
      const realm = process.env.REACT_APP_KEYCLOAK_REALM || "master";
      const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "opensign";
      const redirectUri = `${clientUrl}/sso`;

      // Generate nonce for OIDC security
      const nonce =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem("oidc_nonce", nonce);

      // Generate random state for CSRF protection
      const state =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem("oidc_state", state);

      openInNewTab(
        `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
          redirectUri
        )}&response_type=code&scope=openid%20email%20profile%20organization&state=${state}&nonce=${nonce}`,
        "_self"
      );
    }
  };

  return errMsg ? (
    <div className="h-screen flex justify-center text-center items-center p-4 text-gray-500 text-base">
      {errMsg}
    </div>
  ) : (
    <div>
      <Title title={"Login Page"} />
      {state.loading && (
        <div
          aria-live="assertive"
          className="fixed w-full h-full flex justify-center items-center bg-black bg-opacity-30 z-50"
        >
          <Loader />
        </div>
      )}
      {appInfo && appInfo.appId ? (
        <>
          <div
            aria-labelledby="loginHeading"
            role="region"
            className="md:p-10 lg:p-16"
          >
            <div className="md:p-4 lg:p-10 p-4 bg-base-100 text-base-content op-card">
              <div className="w-[150px] h-[150px] inline-block overflow-hidden">
                {image && (
                  <img
                    src={image}
                    className="object-contain h-full"
                    alt="applogo"
                  />
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2">
                <div>
                  <form onSubmit={handleSubmit} aria-label="Login Form">
                    <h1 className="text-[30px] mt-6">{t("welcome")}</h1>
                    <fieldset>
                      <legend className="text-[12px] text-[#878787]">
                        {t("Login-to-your-account")}
                      </legend>
                      <div className="w-full px-6 py-3 my-1 op-card bg-base-100 shadow-md outline outline-1 outline-slate-300/50">
                        <label className="block text-xs" htmlFor="email">
                          {t("email")}
                        </label>
                        <input
                          id="email"
                          type="email"
                          className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
                          name="email"
                          autoComplete="username"
                          value={state.email}
                          onChange={handleChange}
                          required
                          onInvalid={(e) =>
                            e.target.setCustomValidity(t("input-required"))
                          }
                          onInput={(e) => e.target.setCustomValidity("")}
                        />
                        <hr className="my-1 border-none" />
                        {!isLoginSSO && (
                          <>
                            <label className="block text-xs" htmlFor="password">
                              {t("password")}
                            </label>
                            <div className="relative">
                              <input
                                id="password"
                                type={
                                  state.passwordVisible ? "text" : "password"
                                }
                                className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
                                name="password"
                                value={state.password}
                                autoComplete="current-password"
                                onChange={handleChange}
                                onInvalid={(e) =>
                                  e.target.setCustomValidity(
                                    t("input-required")
                                  )
                                }
                                onInput={(e) => e.target.setCustomValidity("")}
                                required
                              />
                              <span
                                className="absolute cursor-pointer top-[50%] right-[10px] -translate-y-[50%] text-base-content"
                                onClick={togglePasswordVisibility}
                              >
                                {state.passwordVisible ? (
                                  <i className="fa-light fa-eye-slash text-xs pb-1" /> // Close eye icon
                                ) : (
                                  <i className="fa-light fa-eye text-xs pb-1 " /> // Open eye icon
                                )}
                              </span>
                            </div>
                          </>
                        )}
                        <div className="relative mt-1">
                          {isExternalForgotPasswordLink ? (
                            <a
                              href={forgotPasswordLink}
                              target="_blank"
                              rel="noreferrer"
                              className="text-[13px] op-link op-link-primary underline-offset-1 focus:outline-none ml-1"
                            >
                              {t("forgot-password")}
                            </a>
                          ) : (
                            <NavLink
                              to={forgotPasswordLink}
                              className="text-[13px] op-link op-link-primary underline-offset-1 focus:outline-none ml-1"
                            >
                              {t("forgot-password")}
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </fieldset>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-center text-xs font-bold mt-2">
                      <div className="flex flex-row gap-4 justify-center items-center mt-2">
                        <button
                          type="submit"
                          className="op-btn op-btn-primary h-12 px-12 rounded-full text-lg font-semibold"
                          disabled={state.loading}
                        >
                          {state.loading ? t("loading") : t("login")}
                        </button>
                        {isEnableSubscription && (
                          <button
                            type="button"
                            className="op-btn op-btn-accent h-12 px-12 rounded-full text-lg font-semibold border border-[#2d8cff] bg-[#2d8cff] text-white"
                            style={{ minWidth: "200px" }}
                            onClick={handleSignInWithSSO}
                          >
                            {t("sign-SSO")}
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                  {/* {(appInfo.googleClietId || isEnableSubscription) && (
                  {/* ...existing code... */}
                </div>
                {width >= 768 && (
                  <div className="place-self-center">
                    <div className="mx-auto md:w-[300px] lg:w-[400px] xl:w-[500px]">
                      <img
                        src={login_img}
                        alt="The image illustrates a person from behind, seated at a desk with a four-monitor computer setup, in an environment with a light blue and white color scheme, featuring a potted plant to the right."
                        width="100%"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <SelectLanguage />
            {state.alertMsg && (
              <Alert type={state.alertType}>{state.alertMsg}</Alert>
            )}
          </div>
          <ModalUi
            isOpen={isModal}
            title={t("additional-info")}
            showClose={false}
          >
            <form className="px-4 py-3 text-base-content">
              <div className="mb-3">
                <label
                  htmlFor="Company"
                  style={{ display: "flex" }}
                  className="block text-xs text-gray-700 font-semibold"
                >
                  {t("company")}{" "}
                  <span className="text-[red] text-[13px]">*</span>
                </label>
                <input
                  type="text"
                  className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
                  id="Company"
                  value={userDetails.Company}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      Company: e.target.value
                    })
                  }
                  onInvalid={(e) =>
                    e.target.setCustomValidity(t("input-required"))
                  }
                  onInput={(e) => e.target.setCustomValidity("")}
                  required
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="JobTitle"
                  style={{ display: "flex" }}
                  className="block text-xs text-gray-700 font-semibold"
                >
                  {t("job-title")}
                  <span className="text-[red] text-[13px]">*</span>
                </label>
                <input
                  type="text"
                  className="op-input op-input-bordered op-input-sm focus:outline-none hover:border-base-content w-full text-xs"
                  id="JobTitle"
                  value={userDetails.Destination}
                  onChange={(e) =>
                    setUserDetails({
                      ...userDetails,
                      Destination: e.target.value
                    })
                  }
                  onInvalid={(e) =>
                    e.target.setCustomValidity(t("input-required"))
                  }
                  onInput={(e) => e.target.setCustomValidity("")}
                  required
                />
              </div>
              <div className="mt-4 gap-2 flex flex-row">
                <button
                  type="button"
                  className="op-btn op-btn-primary"
                  onClick={(e) => handleSubmitbtn(e)}
                >
                  {t("login")}
                </button>
                <button
                  type="button"
                  className="op-btn op-btn-ghost"
                  onClick={logOutUser}
                >
                  {t("cancel")}
                </button>
              </div>
            </form>
          </ModalUi>
        </>
      ) : (
        <div
          aria-live="assertive"
          className="fixed w-full h-full flex justify-center items-center z-50"
        >
          <Loader />
        </div>
      )}
    </div>
  );
}
export default Login;
